/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import CircularProgress from 'apollo-react/components/CircularProgress';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ZOOM_STYLES } from '../../../../constants/CommonStylesConstants';
import ZoomDialog from '../../../../form-designer/controls/ssZoom/ZoomDialog';
import { getUITA } from '../../../../utils/commonUtils';
import { editEntityInfo } from '../../../actions/entity-designer.actions';

const useStyles = makeStyles(ZOOM_STYLES);

const RightsZoom = ({ prop, isAutoCompleteLoading }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const isMultiSelect = false;

  const renderTitle = 'Rights';

  const handleOnSelect = useCallback(
    (selection) => {
      setDialogOpen(false);
      dispatch(editEntityInfo({ prop, value: selection.RHT_CODE }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <span
        className={classNames(classes.root)}
        style={{ marginLeft: -42, zIndex: 10, marginTop: 7 }}
        onClick={() => !isAutoCompleteLoading[prop] && setDialogOpen(true)}
      >
        {isAutoCompleteLoading[prop] ? (
          <CircularProgress color="inherit" variant="indeterminate" size={24} />
        ) : (
          <Search className={classes.searchIcon} />
        )}
      </span>
      <ZoomDialog
        open={dialogOpen}
        onSelect={handleOnSelect}
        onClose={() => setDialogOpen(false)}
        multiSelect={isMultiSelect}
        entityName="V_RHT_RIGHT"
        initialSearchName="All Rights"
        dataKey="1000"
        customFilter={{}}
        title={renderTitle}
        referencedColumns={[]}
        translatedSearchName={renderTitle}
        ui-ta={getUITA('RightsDialog')}
        dynamicParamCollection={{}}
      />
    </>
  );
};

export default RightsZoom;
